import { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, as: Tag = "div", className = "", ...rest }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setVisible(true), delay);
                    obs.disconnect();
                }
            },
            { threshold: 0.12 }
        );
        obs.observe(node);
        return () => obs.disconnect();
    }, [delay]);

    return (
        <Tag
            ref={ref}
            className={`asc-reveal ${visible ? "is-visible" : ""} ${className}`}
            {...rest}
        >
            {children}
        </Tag>
    );
};
